import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { useGetByIdAbonadoMutation, useCancelarSuscripcionMutation } from '../../../store/api/endpoints/abonadosApiSlice'

import { openFeedback } from '../../../store/slices/feedback'

import HeaderVista from '../../elementos/HeaderVista'
import Loading from '../../elementos/Loading'
import Input from '../../elementos/Input'


import { Breadcrumbs, Button, Divider, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'

import GroupIcon from '@mui/icons-material/Group'
import DeleteIcon from '@mui/icons-material/Delete'
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined'

export default function AbonadoCancelarSuscripcion() {

    const urlParams = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [status_detail, setStatusDetail] = useState('')

    const [
        getRegistro,
        {
            data: responseGetRegistro,
            isUninitialized: isUninitializedGetRegistro,
            isLoading: isLoadingGetRegistro,
            isSuccess: isSuccessGetRegistro,
            isError: isErrorGetRegistro,
            error: errorDataGetRegistro,
        }
    ] = useGetByIdAbonadoMutation()

    const [
        cancelarSuscripcion,
        {
            data: responseCancelarSuscripcion,
            isUninitialized: isUninitializedCancelarSuscripcion,
            isLoading: isLoadingCancelarSuscripcion,
            isSuccess: isSuccessCancelarSuscripcion,
            isError: isErrorCancelarSuscripcion,
            error: errorDataCancelarSuscripcion,
        }
    ] = useCancelarSuscripcionMutation()

    const handleSubmit = (e) => {
        e.preventDefault()
        const body = {
            status_detail
        }
        cancelarSuscripcion({
            idAbonado: urlParams.id,
            body
        })
    }

    useEffect(() => {
        getRegistro(urlParams.id)
    }, [])

    useEffect(() => {
        if (isErrorGetRegistro) {
            dispatch(openFeedback({
                severity: 'error',
                message: errorDataGetRegistro.data.message
            }))
        }
    }, [isErrorGetRegistro])

    useEffect(() => {
        if (isErrorCancelarSuscripcion) {
            dispatch(openFeedback({
                severity: 'error',
                message: errorDataCancelarSuscripcion.data.message
            }))
        }
    }, [isErrorCancelarSuscripcion])

    useEffect(() => {
        if (isSuccessCancelarSuscripcion) {
            dispatch(openFeedback({
                severity: 'success',
                message: "¡Se canceló la suscripción!"
            }))
            navigate(`/abonados/ficha/${urlParams.id}`)
        }
    }, [isSuccessCancelarSuscripcion])

    if (isUninitializedGetRegistro || isLoadingGetRegistro || isLoadingCancelarSuscripcion || isSuccessCancelarSuscripcion) return (<Loading />)

    if (responseGetRegistro.data_pagotic?.estado === "cancelled") return (
        <>
            <HeaderVista
                titulo={
                    <Breadcrumbs aria-label="breadcrumb">
                        <Typography color="text.primary">Abonados</Typography>
                        <Typography color="text.primary">{responseGetRegistro.nombre}</Typography>
                        <Typography color="text.primary">Cancelar Suscripción</Typography>
                    </Breadcrumbs>
                }
                icon={<GroupIcon />}
            />
            <Grid container rowSpacing={2} columnSpacing={1}>
                <Grid size={{ xs: 12 }} sx={{ textAlign: 'center' }}>
                    <h3>Abonado Cancelado</h3>
                    <p>No es posible cancelar la suscripción porque el abonado ya tiene la suscripción cancelada.</p>
                </Grid>
                <Grid size={{ xs: 12, md: 2 }}></Grid>
                <Grid size={{ xs: 12, md: 4 }} sx={{ textAlign: 'left' }}>
                    <p><b>DNI:</b> {responseGetRegistro.dni}</p>
                    <p><b>Nombre:</b> {responseGetRegistro.nombre}</p>
                    <p><b>Email:</b> {responseGetRegistro.email}</p>
                    <p><b>Teléfono:</b> {responseGetRegistro.telefono}</p>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }} sx={{ textAlign: 'left' }}>
                    <p><b>CUIT:</b> {responseGetRegistro.cuit}</p>
                    <p><b>Empresa:</b> {responseGetRegistro.empresa}</p>
                    <p><b>Cond. AFIP:</b> {responseGetRegistro.condicion_afip}</p>
                    <p><b>Comerciante:</b> {responseGetRegistro.comerciante}</p>
                </Grid>
                <Grid size={{ xs: 12, md: 2 }}></Grid>
                <Grid size={{ xs: 12, md: 2 }}></Grid>
                <Grid size={{ xs: 12, md: 6 }} sx={{ textAlign: 'left' }}>
                    <p><b>¿Cómo Llegaste?:</b> {responseGetRegistro.como_llegaste}</p>
                </Grid>
            </Grid>
        </>
    )

    return (
        <>
            <HeaderVista
                titulo={
                    <Breadcrumbs aria-label="breadcrumb">
                        <Typography color="text.primary">Abonados</Typography>
                        <Typography color="text.primary">{responseGetRegistro.nombre}</Typography>
                        <Typography color="text.primary">Cancelar Suscripción</Typography>
                    </Breadcrumbs>
                }
                icon={<GroupIcon />}
            />
            <Grid container rowSpacing={2} columnSpacing={1}>
                <Grid size={{ xs: 12 }} sx={{ textAlign: 'center' }}>
                    <h3>¿Cancelar Suscripción?</h3>
                    <p>Se cancelará la suscripción. Para volver a suscribirse deberá compeltar el formulario de Red Cafira.</p>
                </Grid>
                <Grid size={{ xs: 12, md: 2 }}></Grid>
                <Grid size={{ xs: 12, md: 4 }} sx={{ textAlign: 'left' }}>
                    <p><b>DNI:</b> {responseGetRegistro.dni}</p>
                    <p><b>Nombre:</b> {responseGetRegistro.nombre}</p>
                    <p><b>Email:</b> {responseGetRegistro.email}</p>
                    <p><b>Teléfono:</b> {responseGetRegistro.telefono}</p>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }} sx={{ textAlign: 'left' }}>
                    <p><b>CUIT:</b> {responseGetRegistro.cuit}</p>
                    <p><b>Empresa:</b> {responseGetRegistro.empresa}</p>
                    <p><b>Cond. AFIP:</b> {responseGetRegistro.condicion_afip}</p>
                    <p><b>Comerciante:</b> {responseGetRegistro.comerciante}</p>
                </Grid>
                <Grid size={{ xs: 12, md: 2 }}></Grid>
                <Grid size={{ xs: 12, md: 2 }}></Grid>
                <Grid size={{ xs: 12, md: 6 }} sx={{ textAlign: 'left' }}>
                    <p><b>¿Cómo Llegaste?:</b> {responseGetRegistro.como_llegaste}</p>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Divider />
                </Grid>
            </Grid>
            <form onSubmit={handleSubmit}>
                <Grid container rowSpacing={2} columnSpacing={1}>
                    <Grid size={{ xs: 12 }} sx={{ textAlign: 'center' }}>
                        <p><b>Motivo</b><br />Pagotic requiere un motivo de cancelación.</p>
                    </Grid>
                    <Grid size={{ xs: 12 }} sx={{ textAlign: 'center' }}>
                        <Input
                            label="Motivo de Cancelación"
                            icon={<FeedbackOutlinedIcon />}
                            value={status_detail}
                            onChange={setStatusDetail}
                            type="text"

                            multiline
                            required
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }} sx={{ textAlign: 'center' }}>
                        <Button type="submit" variant="contained" color="error" startIcon={<DeleteIcon />} >
                            Cancelar Suscripción
                        </Button>
                    </Grid>
                </Grid>
            </form>

        </>
    )

}